/**
 * Password Validation Module
 *
 * Handles client-side password validation for inputs with 'password-validate' attribute.
 */

export const initPasswordValidation = () => {
	const passwordInputs = document.querySelectorAll('input[password-validate]');

	if (!passwordInputs.length) {
		return;
	}

	passwordInputs.forEach((input) => {
		input.addEventListener('input', () => {
			validatePassword(input);
		});
	});
};

/**
 * Validate password value
 *
 * @param {HTMLInputElement} input The input element to validate
 */
const validatePassword = (input) => {
	const value = input.value;
	const wrapper = input.closest('.form-wrapper');
	const helperText = wrapper ? wrapper.querySelector('.form-helper-text') : null;
	const validationSuggestion = document.getElementById('password-validation-suggestion');
	const buttonSubmit = document.querySelector('button[disabled-when-invalid]');

	if (!value) {
		validationSuggestion?.querySelector('[rule-title="8-chars"]').classList.remove('success-text');
		validationSuggestion?.querySelector('[rule-title="uppercase"]').classList.remove('success-text');
		validationSuggestion?.querySelector('[rule-title="number"]').classList.remove('success-text');
		validationSuggestion?.querySelector('[rule-title="special-char"]').classList.remove('success-text');
		buttonSubmit?.setAttribute('disabled', true);
		setError(wrapper, helperText, wpcore.direct_t({ en: 'Password is required', fr: 'Le mot de passe est requis' }));
		return;
	}

	const errors = [];

	if (value.length < 8) {
		errors.push(wpcore.direct_t({ en: 'at least 8 characters', fr: 'au moins 8 caractères' }));
		validationSuggestion?.querySelector('[rule-title="8-chars"]').classList.remove('success-text');
		buttonSubmit?.setAttribute('disabled', true);
	} else {
		validationSuggestion?.querySelector('[rule-title="8-chars"]').classList.add('success-text');
		buttonSubmit?.removeAttribute('disabled');
	}
	if (!/[A-Z]/.test(value)) {
		errors.push(wpcore.direct_t({ en: 'one uppercase letter', fr: 'une lettre majuscule' }));
		validationSuggestion?.querySelector('[rule-title="uppercase"]').classList.remove('success-text');
		buttonSubmit?.setAttribute('disabled', true);
	} else {
		validationSuggestion?.querySelector('[rule-title="uppercase"]').classList.add('success-text');
		buttonSubmit?.removeAttribute('disabled');
	}
	if (!/\d/.test(value)) {
		errors.push(wpcore.direct_t({ en: 'one number', fr: 'un nombre' }));
		validationSuggestion?.querySelector('[rule-title="number"]').classList.remove('success-text');
		buttonSubmit?.setAttribute('disabled', true);
	} else {
		validationSuggestion?.querySelector('[rule-title="number"]').classList.add('success-text');
		buttonSubmit?.removeAttribute('disabled');
	}
	if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
		errors.push(wpcore.direct_t({ en: 'one special character', fr: 'un caractère spécial' }));
		validationSuggestion?.querySelector('[rule-title="special-char"]').classList.remove('success-text');
		buttonSubmit?.setAttribute('disabled', true);
	} else {
		validationSuggestion?.querySelector('[rule-title="special-char"]').classList.add('success-text');
		buttonSubmit?.removeAttribute('disabled');
	}

	if (errors.length > 0) {
		const errorMessage = wpcore.direct_t({ en: 'Password must contain ', fr: 'Le mot de passe doit contenir ' }) + errors.join(', ');
		setError(wrapper, helperText, errorMessage);
		buttonSubmit?.setAttribute('disabled', true);
	} else {
		clearError(input);
		buttonSubmit?.removeAttribute('disabled');
	}
};

/**
 * Set error state
 *
 * @param {HTMLElement} wrapper The form wrapper element
 * @param {HTMLElement} helperText The helper text element
 * @param {string} message The error message
 */
const setError = (wrapper, helperText, message) => {
	if (wrapper) {
		wrapper.classList.add('form-wrapper-error');
	}
	if (helperText) {
		helperText.classList.add('block!');
		helperText.textContent = message;
	}
};

/**
 * Clear error state
 *
 * @param {HTMLInputElement} input The input element
 */
const clearError = (input) => {
	const wrapper = input.closest('.form-wrapper');
	const helperText = wrapper ? wrapper.querySelector('.form-helper-text') : null;

	if (wrapper) {
		wrapper.classList.remove('form-wrapper-error');
	}
	if (helperText) {
		helperText.classList.remove('block!');
		helperText.textContent = '';
	}
};
